import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

const PortalContainer = styled.div`
  position: fixed;
  z-index: 9999;
`;

interface AnchoredPortalProps {
  anchorRef: React.RefObject<HTMLElement | null>;
  children: React.ReactNode;
}

export const AnchoredPortal = ({ anchorRef, children }: AnchoredPortalProps) => {
  const [style, setStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    const updatePosition = () => {
      if (anchorRef.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        setStyle({
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
        });
      }
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [anchorRef]);

  return createPortal(<PortalContainer style={style}>{children}</PortalContainer>, document.body);
};
